import { useEffect, useState } from "react";
import API from "../lib/api";
import { Badge } from "./ui/badge";

// Cross-tenant outreach summary — platform admins only (renders nothing for everyone else)
export function OutreachPlatformOverview({ user }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!user?.is_platform_admin) return;
    API.get("/platform/supplier-outreach/overview").then(({ data }) => setRows(data.tenants || [])).catch(() => setRows([]));
  }, [user?.is_platform_admin]);

  if (!user?.is_platform_admin || !rows || rows.length === 0) return null;

  return (
    <div className="rounded-lg border bg-card p-4" data-testid="outreach-platform-overview">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold font-[Chivo]">All tenants — outreach overview</h2>
        <span className="text-[11px] text-muted-foreground">Platform view · {rows.length} tenant{rows.length === 1 ? "" : "s"} configured</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-muted-foreground border-b">
              <th className="py-1.5 pr-3 font-medium">Tenant</th>
              <th className="py-1.5 pr-3 font-medium">Status</th>
              <th className="py-1.5 pr-3 font-medium text-right">Sent</th>
              <th className="py-1.5 pr-3 font-medium text-right">Applied</th>
              <th className="py-1.5 pr-3 font-medium text-right">Joined</th>
              <th className="py-1.5 pr-3 font-medium text-right">Opt-outs</th>
              <th className="py-1.5 font-medium">Last run</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.tenant_id} className="border-b last:border-0" data-testid={`outreach-overview-${r.slug || r.tenant_id}`}>
                <td className="py-1.5 pr-3 font-medium">{r.tenant_name}</td>
                <td className="py-1.5 pr-3">
                  <Badge variant={r.enabled ? "default" : "outline"} className="text-[10px]">{r.enabled ? `On · ${r.run_time} · cap ${r.daily_cap}` : "Off"}</Badge>
                </td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.total_sent}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.applied}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.joined}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{r.opted_out}</td>
                <td className="py-1.5 text-muted-foreground">{r.last_run?.finished_at ? new Date(r.last_run.finished_at).toLocaleString() : r.last_run?.status || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
